
<div class="theme2 footer-container p-3">
   <div class="flex flex-row justify-content-between">
        <a href="/"><img src="assets/img/logo-new.png" alt="Image" height="50"></a>
        <div class="footer-links">
            <a href="/contact">{{'general.contact' | translate}}</a>
        </div>
   </div>
</div>
